import type { SVGProps } from 'react';
export const SvgNext = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		aria-hidden="true"
		className="w-6 h-6 text-white"
		viewBox="0 0 8 14"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m1 13 5.7-5.326a.91.91 0 0 0 0-1.348L1 1"
		/>
	</svg>
);
